export default "__VITE_ASSET__Bt6I2Ki0__"